<div class="ui-file-upload">
  @if (label()) {
    <label class="ui-file-upload__label">{{ label() }}</label>
  }

  <div
    class="ui-file-upload__zone"
    [class.ui-file-upload__zone--dragging]="dragging()"
    [class.ui-file-upload__zone--disabled]="disabled()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)"
  >
    <input
      class="ui-file-upload__input"
      type="file"
      [accept]="accept()"
      [multiple]="multiple()"
      [disabled]="disabled()"
      (change)="onSelect($event)"
    />
    <span class="ui-file-upload__icon" aria-hidden="true">
      <ui-icon name="upload" />
    </span>
    <span class="ui-file-upload__text">
      Glissez-déposez vos fichiers ici ou <span class="ui-file-upload__browse">parcourez</span>
    </span>
  </div>

  @if (files().length) {
    <ul class="ui-file-upload__list">
      @for (file of files(); track file.name; let i = $index) {
        <li class="ui-file-upload__item">
          <ui-icon name="attachment" size="sm" />
          <span class="ui-file-upload__name">{{ file.name }}</span>
          <button type="button" class="ui-file-upload__remove" aria-label="Retirer le fichier" (click)="remove(i)">
            <ui-icon name="close" size="sm" />
          </button>
        </li>
      }
    </ul>
  }

  @if (hint()) {
    <p class="ui-file-upload__hint">{{ hint() }}</p>
  }
</div>
